const actionTypes = require('constants/actionTypes');
const Immutable = require('immutable');

const setInitialState = () => {
    return Immutable.Map().merge({
        filesToUpload: [],
        filesInfo: {},
    });
};

const initialState = setInitialState();

const documentationReducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case actionTypes.GET_DOCUMENT_INFO:
            if (action.data) {
                let filesToUpload = state.get('filesToUpload');

                action.data.documents.map(value => {
                    filesToUpload = filesToUpload.push(
                        Immutable.Map({
                            docId: value.docId,
                            status: value.status,
                        }).toObject()
                    );
                });
                return state.merge({
                    filesToUpload: filesToUpload,
                    filesInfo: {
                        accountType: action.data.accountType,
                        ...(action.data.vedacon !== undefined && { vedacon: action.data.vedacon }),
                    },
                });
            } else {
                return state;
            }

        case actionTypes.CLEAR_DOCUMENT_INFO:
            return state.merge({
                filesToUpload: [],
                filesInfo: {},
            });

        default:
            return state;
    }
};

module.exports = documentationReducer;
